import { css } from "@emotion/css";
import { Spacing } from "@snapchat/snap-design-system";

export const formCSS = css`
    padding: ${Spacing.XL}px !important; /* overwriting base form styles */
`;
